import React from 'react';
import { DataDefinitionList, ButtonOBSOLETED } from '../../../../../web.common';
import CreateEntity from '../../../../misc/CreateEntity';
import { fields } from './fields';
import { formValidation } from './formValidation';
import { getFormData } from './getFormData';
import withApi from '../../../../higherOrderComponents/withApi';

class CreateProductFieldInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { close, productId, api: { products: { createProductField } } } = this.props;
    const createData = async data => createProductField(data, productId);
    const entity = 'product field';
    const editProps = {
      createData,
      language: 'en',
      entity,
      getFormData,
      onSaveCompleted: outcome => {
        if (!outcome) {
          return;
        }

        close(true);
      },
      validation: formValidation()
    };

    return (
      <div>
        <h2>Create Field</h2>
        <CreateEntity {...editProps}>
          {formData => (
            <DataDefinitionList
              classNames={['border-0']}
              listData={fields(true, formData)}
              hasWideDescriptions
            />
          )}
        </CreateEntity>
        <br />
        <ButtonOBSOLETED
          type='button'
          isFullWidth
          buttonColor='gray'
          buttonContent={<div>Close</div>}
          onClick={() => {
            close();
          }}
        />
      </div>
    );
  }
}

export const CreateProductField = withApi(CreateProductFieldInternal);